import '@revenuewell/ui-icons/ui-icons.esm.css';
import './modules/membership/membership.css';
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Paper, Typography, Grid } from '@mui/material';
import { AppChoice, useAppContext } from './context/app-context';
import classNames from 'classnames';
import { useSharedAssignmentStyles } from './modules/assignments/index.module';
import PinDialog from './modules/shared/pin-dialog';

const AppChooserSkeleton: React.FC = () => {
    const classes = useSharedAssignmentStyles();
    return (<Paper className={classNames(classes.assignmentsListSection)} elevation={3}></Paper>);
};

interface AppChooserProps {
    locationId: number;
}


const AppChooser: React.FC<AppChooserProps> = (props) => {
    const { setAppChoice, goToPatientApp } = useAppContext();
    const [openDialogue, setOpenDialogue] = useState(true);
    const [openPinDialogue, setOpenPinDialogue] = useState(false);

    return (
        <>
            <AppChooserSkeleton />
            <Dialog
                disableEscapeKeyDown
                maxWidth="lg"
                aria-labelledby="confirmation-dialog-title"
                open={openDialogue}

            >
                <DialogTitle id="confirmation-dialog-title">Welcome to Forms!</DialogTitle>
                <DialogContent sx={{ minWidth: '400px' }}>
                    <DialogContentText>
                        Where can we take you today?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>

                    <Grid container spacing={5} sx={{ width: '500px' }}>
                        <Grid item xs={6}>
                            <Button variant="outlined" onClick={() => { setOpenPinDialogue(true); setOpenDialogue(false); }} sx={{ width: '100%', marginBottom: '25px' }}>
                                TABLET EXPERIENCE
                            </Button>
                            <Typography variant="body1">Select patients, assign forms, and let them complete forms on a tablet. Replaces the iPad Forms app.</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Button variant="outlined" onClick={() => setAppChoice(AppChoice.Practice)} sx={{ width: '100%', marginBottom: '25px' }}>
                                PRACTICE EXPERIENCE
                            </Button>
                            <Typography variant="body1">Access all forms functionality typically used by office staff.</Typography>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <PinDialog title='Create your PIN' subtitle='To ensure that only authorized office employees can access sensitive data, please create a PIN to return to Assignments after your patient is done filling out their forms.' showCloseIcon
                open={openPinDialogue}
                handlePinContinueToForms={() => goToPatientApp(props.locationId)}
                handleClose={() => setOpenPinDialogue(false)}
                cancelText='Cancel' />        </>);

}

export default AppChooser;